import { ProformaEmployeeCostReportDTO } from "src/models/proforma-employee-cost-report/proforma-employee-cost-report-dto";
import { ProformaEmployeeCostReportSTO } from "src/models/proforma-employee-cost-report/proforma-employee-cost-report-sto";
import { BaseApiService } from "../base";

export class ProformaEmployeeCostReportApiService extends BaseApiService<
  ProformaEmployeeCostReportDTO,
  ProformaEmployeeCostReportSTO
> {
  constructor() {
    super({
      servicePath: "/ProformaEmployeeCostReport",
      loadItemsPath: "/GetProformaEmployeeCostReports",
      saveItemsPath: "/SaveProformaEmployeeCostReports",
    });
  }
}
